import localStorageService from '../api/localStorageService'
import { sortByProperty } from '../helpers/utils'
import { API } from './../api/api'
import { fetch } from './../api/httpClient'

export const getAllDistricts = () => async () => {
  try {
    const url = `${API.CORE.GETALLDISTRICT}`
    const { data } = await fetch(url)
    localStorageService.setAllDistrict(data)
  } catch (error) {
    console.log(error)
  }
}

export const fetchAllDistrictsCall = (successCallback) => async () => {
  try {
    let data = localStorageService.getAllDistrict()
    sortByProperty(data, 'dst_name')

    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    console.log(error)
  }
}

export const fetchDistrictByIdCall = (id, successCallback) => async () => {
  try {
    let data = localStorageService.getAllDistrict().find((district) => {
      return district.dst_id === id || district.dst_district_public_id === id
    })

    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    console.log(error)
  }
}

export const getAllSchools = () => async () => {
  try {
    const url = `${API.CORE.GETALLSCHOOL}`
    const { data } = await fetch(url)
    sortByProperty(data, 'sch_name')
    localStorageService.setAllSchool(data)
  } catch (error) {
    console.log(error)
  }
}

export const fetchAllSchoolsCall = (id, successCallback) => async () => {
  try {
    let data = localStorageService.getAllSchool().filter((school) => {
      return (
        school.sch_dst_id === id.districtId ||
        school?.sch_district?.dst_district_public_id === id.districtId
      )
    })
    sortByProperty(data, 'sch_name')

    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    console.log(error)
  }
}
